module.exports = "assets/icon-ext.png?ba81b2";


//////////////////
// WEBPACK FOOTER
// ../node_modules/layui-layer/icon-ext.png
// module id = 18
// module chunks = 1